export function setPartner(state, payload) {
    state.partner = payload;
}

export function setPartners(state, payload) {
    state.partners = payload;
}

export function setPartnersLoaded(state, payload) {
    state.partnersLoaded = payload;
}

export function updatePartner(state, partner) {
    let index = state.partners.findIndex((el) => el.id === partner.id);
    state.partners[index] = partner;
}

export function setApplications(state, payload) {
    state.applications = payload;
}

export function setApplicationsLoaded(state, payload) {
    state.applicationsLoaded = payload;
}

export function setAdministrators(state, payload) {
    state.administrators = payload;
}

export function setAdministratorsLoaded(state, payload) {
    state.administratorsLoaded = payload;
}

export function setTransactions(state, { results, totalCount }) {
    state.transactions = [];
    state.transactions = results;
    state.transactionsTotal = totalCount;
}

export function setTransactionsLoading(state, payload) {
    state.transactionsLoading = payload;
}

export function setTransactionsSums(state, payload) {
    state.transactionsSums = payload;
}

export function setCommissions(state, payload) {
    state.commissions = payload;
}

export function setCommissionsLoaded(state, payload) {
    state.commissionsLoaded = payload;
}

export function setApplicationApprove(state, payload) {
    state.applicationApprove = payload;
}

export function removeCommission(state, payload) {
    let index = state.commissions.findIndex((el) => el.id === payload.id);
    state.commissions.splice(index, 1);
}

export function addCommission(state, commission) {
    state.commissions.push(commission);
}

export function updateCommission(state, commission) {
    let index = state.commissions.findIndex((el) => el.id === commission.id);
    state.commissions[index] = commission;
}

export function replaceTransaction(state, payload) {
    let index = state.transactions.findIndex((el) => el.id === payload.oldId);
    state.transactions[index] = payload.transaction;
}

export function setAffiliates(state, payload) {
    state.affiliates = payload;
}

export function setAffiliatesLoaded(state, payload) {
    state.affiliatesLoaded = payload;
}
